var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vs-upload',{on:{"change":_vm.changeHandle,"on-delete":_vm.deleteHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }